import React from "react"
import PropTypes from "prop-types"

import styles from "./appbar-body.module.css"

export const AppbarBody = ({ children, ...props }) => {
  // filtering out style and className
  /* eslint-disable-next-line react/prop-types */
  const { style, className, ...rest } = props

  return (
    <div {...rest} className={styles.AppbarBody}>
      {children}
    </div>
  )
}

AppbarBody.displayName = "AppbarBody"

AppbarBody.propTypes = {
  /**
   * Container for the AppbarBody content.
   */
  children: PropTypes.node.isRequired,
}
